import { useCallback, useEffect, useRef, useState } from "react";
import { CircularTimer } from "./CircularTimer";

const ROUND_DURATION = 15;

interface RoundTimerProps {
  readonly deadline: number | null;
  readonly onTimeout: () => void;
  readonly isHost: boolean;
}

export function RoundTimer({ deadline, onTimeout, isHost }: RoundTimerProps) {
  const [remaining, setRemaining] = useState(ROUND_DURATION);
  const timeoutFiredRef = useRef(false);

  useEffect(() => {
    if (!deadline) {
      setRemaining(ROUND_DURATION);
      timeoutFiredRef.current = false;
      return;
    }

    timeoutFiredRef.current = false;

    function tick() {
      const now = Date.now();
      const left = Math.max(0, Math.ceil((deadline! - now) / 1000));
      setRemaining(left);
    }

    tick();
    const intervalId = setInterval(tick, 200);
    return () => clearInterval(intervalId);
  }, [deadline]);

  const handleTimeout = useCallback(() => {
    if (isHost) {
      onTimeout();
    }
  }, [isHost, onTimeout]);

  useEffect(() => {
    if (remaining <= 0 && deadline && !timeoutFiredRef.current) {
      timeoutFiredRef.current = true;
      handleTimeout();
    }
  }, [remaining, deadline, handleTimeout]);

  return <CircularTimer remaining={remaining} total={ROUND_DURATION} />;
}
